"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createOwnerPagedReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _CacheKeys = require("reference-resolvers/constants/CacheKeys");

var _OwnersAPI = require("reference-resolvers/api/OwnersAPI");

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var createOwnerPagedReferenceResolver = function createOwnerPagedReferenceResolver(options) {
  return (0, _createBatchedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.OWNERS,
    createFetchByIds: _OwnersAPI.createGetOwnersById,
    createFetchSearchPage: _OwnersAPI.createGetOwnersSearchPage,
    fetchByIds: _OwnersAPI.getOwnersById,
    fetchSearchPage: _OwnersAPI.getOwnersSearchPage
  }, options));
};

exports.createOwnerPagedReferenceResolver = createOwnerPagedReferenceResolver;

var _default = createOwnerPagedReferenceResolver();

exports.default = _default;